<template>
    <Header></Header>
    <div class="container sub_page _report">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/report_left_01.png" /></i>
                <i class="deco_02 spin_blink1 _small"><img src="img/b_icon_03.png" /></i>
                <i class="deco_03 blink_zoom1 _xxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_04 blink_blink4 _xxxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>

                <i class="deco_character"><img src="img/report_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민제보창</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)"><a href="javascript:void(0)">성매매 의심 업소 제보</a></li>
                    <li @click="changeTab(2)" class="active"><a href="javascript:void(0)">성매매 알선 광고 제보</a></li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120 report_area">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!--                 
                <span class="icon_wrap"><img src="img/part_icon.png" alt="시민제보창" /></span>
                <a href="">시민제보창</a> 
                -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="성매매 알선 광고 제보" /></span>
                <router-link :to="{ path: '/report', query: { type: 2 } }">성매매 알선 광고 제보</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="성매매 알선 광고 제보글" /></span>
                <a href="javascript:void(0)" style="cursor: default">성매매 알선 광고 제보글</a>
            </div>

            <div class="sub_con_banner">
                <div v-html="CommonUtils.decodeContent(state.menuContent)"></div>
                <div class="link con_list">
                    <p>시민제보 처리과정이 궁금하신가요?</p>
                    <router-link to="/faqList" @click="global.setIntroTab(3)" class="action_btn">
                        <span>과정 보러가기</span>
                        <img src="img/move_btn.png" alt="" />
                    </router-link>
                </div>
            </div>

            <div class="sub_page_con_view con_view" v-if="!state.isShowModal">
                <div class="tit_wrap">
                    <span class="con_num no_768">{{ state.data.idx }}</span>
                    <span class="con_tit">성매매 알선 광고 제보</span>
                    <span class="con_date" style="width: 180px">{{ CommonUtils.dateFormat(new Date(state.data.createDate), ".", true) }}</span>
                </div>
                <div class="con_table_wrap">
                    <div class="cate_wrap">
                        <span class="cate" :class="[state.data.state === 2 ? 'green' : '']">
                            {{ state.data.state === 1 ? "대기중" : "접수완료" }}
                        </span>
                    </div>
                    <ul>
                        <li>
                            <div class="con_th">제보자 닉네임</div>
                            <div>{{ state.data.nickname }}</div>
                        </li>
                        <li>
                            <div class="con_th">업소명</div>
                            <div>{{ state.data.shopName }}</div>
                        </li>
                        <li>
                            <div class="con_th">업소주소</div>
                            <div>{{ state.data.address }} {{ state.data.addressDetail }}</div>
                        </li>
                        <li>
                            <div class="con_th">업소 전화번호</div>
                            <div>{{ state.data.number }}</div>
                        </li>
                        <li>
                            <div class="con_th">업소 URL</div>
                            <div>{{ state.data.adUrl }}</div>
                        </li>
                        <li class="areaContent">
                            <div class="con_th">내용</div>
                            <div class="user_content" v-html="state.data.content"></div>
                        </li>
                        <li v-if="state.data.fileList != null && state.data.fileList.length > 0">
                            <div class="con_th">파일 다운로드</div>
                            <div class="file_list_wrap">
                                <div v-for="item in state.data.fileList" :key="item.idx" :class="state.isMobile768 ? '_flex' : ''">
                                    <span :class="!state.isMobile768 ? 'file_name' : 'file_name elips_1'" v-text="item.imgRealName"></span>
                                    <button class="common_style" @click="downloadFile(item.file, item.imgRealName)">파일 다운로드</button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn_wrap _default right_btn">
                <button class="common_btn _gray" @click="isDelete" v-if="state.data.state === 1">삭제</button>
                <button class="common_btn" v-if="state.data.state === 1" @click="router.push({ name: 'AdModify', params: { id: state.idx } })">
                    수정
                </button>
                <button class="common_btn" @click="router.replace('/report?type=2')">목록</button>
            </div>

            <div class="report_chk_wrap" v-if="state.hasAuth && !state.isMobile">
                <div class="radio_wrap flex_half">
                    <span class="input_tit">게시글 상태</span>
                    <div class="input_wrap">
                        <label for="chk1_yes">
                            <input type="radio" name="chk1" id="chk1_yes" :checked="state.data.state === 1" @click="state.data.state = 1" />
                            <em></em>
                            <span>대기중</span>
                        </label>
                        <label for="chk1_no">
                            <input type="radio" name="chk1" id="chk1_no" :checked="state.data.state === 2" @click="state.data.state = 2" />
                            <em></em>
                            <span>접수완료</span>
                        </label>
                    </div>
                </div>
                <template v-if="state.data.state === 2">
                    <div class="flex_half">
                        <span class="input_tit">업종분류</span>
                        <div class="select_tab_box _board_type">
                            <div
                                class="selected_tab"
                                :class="[state.isActive ? 'active' : '']"
                                @click="
                                    state.isActive = !state.isActive;
                                    (state.isPossible = false), (state.isPossible2 = false), (state.isReason = false);
                                "
                            >
                                <span>{{ state.category.find((c: any) => c.caIdx === state.data.gubun)?.caName }}</span>
                            </div>
                            <div class="tab_option">
                                <button
                                    v-for="item in state.category"
                                    :key="item.caIdx"
                                    @click="
                                        state.data.gubun = item.caIdx;
                                        state.isActive = false;
                                    "
                                    :class="[state.data.gubun === item ? 'active' : '']"
                                >
                                    {{ item.caName }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="radio_wrap">
                        <span class="input_tit">고발/ 신고여부</span>
                        <div class="select_wrap _column">
                            <div>
                                <label for="chk2_yes">
                                    <input
                                        type="radio"
                                        name="chk2"
                                        id="chk2_yes"
                                        :checked="state.data.isReport === 1"
                                        @click="state.data.isReport = 1"
                                    />
                                    <em></em>
                                    <span>가능</span>
                                </label>
                                <div class="select_tab_box _board_type" v-if="state.data.isReport === 1">
                                    <div
                                        class="selected_tab"
                                        :class="[state.isPossible ? 'active' : '']"
                                        @click="
                                            state.isPossible = !state.isPossible;
                                            (state.isActive = false), (state.isPossible2 = false), (state.isReason = false);
                                        "
                                    >
                                        <span>{{ state.data.reportState === 2 ? "고발" : "신고" }}</span>
                                    </div>

                                    <div class="tab_option">
                                        <button @click="selectReportState(1)">신고</button>
                                        <button @click="selectReportState(2)">고발</button>
                                    </div>
                                </div>
                                <div v-if="state.data.isReport === 1 && state.data.reportState === 1" class="select_tab_box _board_type">
                                    <div
                                        class="selected_tab"
                                        :class="[state.isPossible2 ? 'active' : '']"
                                        @click="
                                            state.isPossible2 = !state.isPossible2;
                                            (state.isActive = false), (state.isPossible = false), (state.isReason = false);
                                        "
                                    >
                                        <span v-if="state.data.reportType === 1">국민신문고</span>
                                        <span v-else-if="state.data.reportType === 2">방통위</span>
                                        <span v-else-if="state.data.reportType === 3">기타</span>
                                    </div>
                                    <div class="tab_option">
                                        <button
                                            @click="
                                                state.isPossible2 = false;
                                                state.data.reportType = 1;
                                            "
                                        >
                                            국민신문고
                                        </button>
                                        <button
                                            @click="
                                                state.isPossible2 = false;
                                                state.data.reportType = 2;
                                            "
                                        >
                                            방통위
                                        </button>
                                        <button
                                            @click="
                                                state.isPossible2 = false;
                                                state.data.reportType = 3;
                                            "
                                        >
                                            기타
                                        </button>
                                    </div>
                                </div>
                                <div v-else-if="state.data.isReport === 1 && state.data.reportState === 2" class="input_text_wrap">
                                    <input
                                        name="reportState"
                                        type="text"
                                        placeholder="고발 사유를 입력해주세요."
                                        class="custom_input"
                                        v-model="state.data.reportMemo"
                                    />
                                </div>
                            </div>

                            <div>
                                <label for="chk2_no">
                                    <input
                                        type="radio"
                                        name="chk2"
                                        id="chk2_no"
                                        :checked="state.data.isReport === 2"
                                        @click="state.data.isReport = 2"
                                    />
                                    <em></em>
                                    <span>불가능</span>
                                </label>

                                <div class="select_tab_box _board_type" v-if="state.data.isReport === 2">
                                    <div
                                        class="selected_tab"
                                        :class="[state.isReason ? 'active' : '']"
                                        @click="
                                            state.isReason = !state.isReason;
                                            (state.isActive = false), (state.isPossible = false), (state.isPossible2 = false);
                                        "
                                    >
                                        <span>{{ currentReason }}</span>
                                    </div>

                                    <!-- 선택 가능한 버튼 영역 -->
                                    <div class="tab_option" v-if="state.isReason">
                                        <button
                                            v-for="(label, idx) in reasons"
                                            :key="idx"
                                            @click="selectReason(idx + 1)"
                                            :class="{ active: (state.data.reason || 1) === idx + 1 }"
                                        >
                                            {{ label }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div>
                    <textarea class="custom_scroll light_gray" placeholder="메모" v-model="state.data.memo"></textarea>
                </div>
                <div class="btn_wrap _default admin_save_btn right_btn">
                    <button type="button" @click="stateSave" class="common_btn">저장</button>
                </div>
            </div>

            <div class="reply_container" v-if="state.hasAuth || state.comments.length > 0">
                <div class="reply_wrap admin_reply_wrap">
                    <div class="my_reply reply_box" v-if="state.hasAuth">
                        <div class="reply_writer">
                            <img src="img/symbol.png" alt="" />
                            다시함께상담센터
                        </div>
                        <textarea textarea name="" id="" class="reply_con custom_scroll" v-model="form_state.commentContent"></textarea>
                        <button class="reply_submit" alt="댓글 등록" @click="commentAdd">
                            <img src="img/reply_uoload.png" alt="" />
                        </button>
                    </div>

                    <ul class="" v-if="state.comments.length > 0" :class="[state.hasAuth ? 'replies' : '']">
                        <li class="reply_box" v-for="(item, index) in state.comments" :key="index">
                            <template v-if="!state.isMobile">
                                <div class="reply_writer">
                                    <img src="img/symbol.png" alt="" />
                                    <span>다시함께상담센터</span>
                                </div>

                                <div class="reply_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                                <div class="reply_btn" v-if="state.hasAuth">
                                    <template v-if="comment_state.idx !== item.idx">
                                        <button type="button" @click="commentModify(item)">수정</button>
                                        <button type="button" @click="confirmCommentRemove(item.idx)" class="_gray">삭제</button>
                                    </template>
                                    <template v-else-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                        <button type="button" @click="commentSave(item)">저장</button>
                                        <button type="button" @click="commentCancel()" class="_gray">취소</button>
                                    </template>
                                </div>

                                <div class="reply_con" v-html="item.content.replaceAll('\n', '<br>')" v-if="comment_state.idx !== item.idx"></div>
                                <textarea class="reply_con" v-model="comment_state.content" v-else></textarea>
                            </template>
                            <template v-else>
                                <div class="replay_area_for_mobile">
                                    <div class="reply_writer">
                                        <img src="img/symbol.png" alt="" />
                                        <span>다시함께상담센터</span>
                                    </div>
                                    <div class="reply_area_right">
                                        <div class="reply_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                                        <button @click="edit(item)" style="margin-left: 10px" v-if="state.hasAuth">
                                            <img src="img/kebabIcon.png" style="height: 18px; width: auto" />
                                        </button>
                                        <div
                                            class="reply_btn"
                                            v-show="state.isShowBtn && comment_state.idx === item.idx"
                                            :class="state.isShowBtn && comment_state.idx === item.idx ? '_mobile' : ''"
                                        >
                                            <template v-if="comment_state.mode !== 'modify' && comment_state.idx === item.idx">
                                                <button type="button" @click="commentModify(item)">수정</button>
                                                <button type="button" @click="confirmCommentRemove(item.idx)" class="_gray">삭제</button>
                                            </template>
                                            <template v-else-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                                <button type="button" @click="commentSave(item)">저장</button>
                                                <button type="button" @click="commentCancel()" class="_gray">취소</button>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="comment_state.mode === 'modify' && comment_state.idx === item.idx">
                                    <div style="width: 100%">
                                        <input type="password" v-model="comment_state.pw" placeholder="비밀번호를 입력해주세요." />
                                    </div>
                                </template>

                                <div
                                    class="reply_con"
                                    v-html="item.content.replaceAll('\n', '<br>')"
                                    v-if="(comment_state.mode !== 'modify' && comment_state.idx === item.idx) || comment_state.idx !== item.idx"
                                ></div>
                                <textarea class="reply_con" v-model="comment_state.content" v-else></textarea>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        Header,
        Footer,
        types,
        apiService,
        useRoute,
        userStore,
        CommonUtils,
        ModalDefault,
        getMessageByCode,
    } from "@/BaseComponent";
    import { computed, onBeforeMount } from "vue";

    export default {
        components: { Header, Footer, ModalDefault },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,
                idx: 0 as number,
                menuContent: "" as string,

                data: {} as types.ResReportVOForApi,
                comments: [] as any,
                category: [] as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                page: 1 as number,
                size: 1000 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                hasAuth: false,

                isActive: false as boolean,
                isPossible: false as boolean,
                isPossible2: false as boolean,
                isReason: false as boolean,

                subMenuOpen: false as boolean,
                subMenuName: "성매매 알선 광고 제보" as string,

                isMobile: false,
                isMobile768: false,
                isShowBtn: false,
            });

            const reasons = ["내용부족", "주소 불명확", "온라인 모니터링 불가", "게시판 오신고", "중복", "기타"];

            const form_state = reactive({
                idx: 0 as number,
                commentContent: "" as string,
            });

            const comment_state = reactive({
                mode: "" as string,
                idx: 0 as number,
                pw: "" as string,
                content: "" as string,
            });

            const comment_state2 = reactive({
                idx: 0 as number,
            });

            onBeforeMount(() => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("ad") > -1)))
                )
                    state.hasAuth = true;
            });

            onMounted(() => {
                const idx = Number(route.params.id);

                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;

                    if (user.isLogin()) {
                        getDetail();
                        getCategory();
                    } else {
                        confirmModal();
                    }
                } else {
                    router.back();
                }

                getMenuTitle();

                state.isMobile = window.innerWidth < 450;
                state.isMobile768 = window.innerWidth < 768;
            });

            const confirmModal = () => {
                state.modalTab = 3;
                state.modalTitle = "알림";
                state.modalContent = "제보 시 설정한 비밀번호를 입력해주세요.";
                state.isShowModal = true;
            };

            const getMenuTitle = async () => {
                const res = await apiService.report.menuDetail(2);
                if (res.returnCode === 0) {
                    state.menuContent = res.data.headerTitle;
                } else if (res.returnCode === 11) {
                } else {
                    console.error(res.description);
                }
            };

            const changeTab = (tab: number) => {
                global.setReportTab(tab);
                router.push("/report?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "성매매 의심 업소 제보";
                        break;
                    case 2:
                        state.subMenuName = "성매매 알선 광고 제보";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const getDetail = async () => {
                const res = await apiService.report.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data.meIdx === user.userInfo.idx || state.hasAuth) {
                        getComments();
                        state.data = res.data;

                        if (state.data.isReport === null) {
                            state.data.isReport = 1;
                        }
                        if (state.data.reportState === null) {
                            state.data.reportState = 1;
                        }
                        if (state.data.reportType === null) {
                            state.data.reportType = 1;
                        }
                    } else {
                        confirmModal();
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getCategory = async () => {
                const res = await apiService.category.list();

                if (res.returnCode === 0) {
                    state.category = res.data;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getConfirm = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };

                const res = await apiService.report.confirmPw(param);
                if (res.returnCode === 0) {
                    state.isShowModal = false;
                    getDetailWithPw(pw);
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getDetailWithPw = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };

                const res = await apiService.report.confirmDetail(param);
                if (res.returnCode === 0) {
                    state.data = res.data;
                    getComments();
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getComments = async () => {
                const param: types.ReqReportCommentList = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };

                const res: types.ResReportCommentList = await apiService.report.commentList(state.idx, param);

                if (res.returnCode === 0) {
                    state.comments = res.list.data;
                } else if (res.returnCode === 11) {
                } else {
                    console.error(res.description);
                }
            };

            const removeData = async (idx: number) => {
                const res = await apiService.report.remove(idx);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeConfirmData = async (param: types.ReqConfirmPw) => {
                const res = await apiService.report.confirmRemove(param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeDataForComfirm = async (idx: number) => {
                const res = await apiService.report.commentDelete(2, idx);
                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;

                    getComments();
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 19) {
                    // state.modalTab = 8;
                    // state.modalTitle = "삭제 실패";
                    // state.modalContent = "비밀번호를 잘못 입력하셨네요.";
                    // state.isShowModal = true;
                } else if (res.returnCode === 22) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (!(state.modalTab === 4 || state.modalTab === 5 || state.modalTab === 8 || state.modalTab === 9 || state.modalTab === 10))
                    router.replace("/report?type=2");
            };

            const callBackModal = async (param: any) => {
                if (param.action === "checkPw") {
                    getConfirm(param.pw);
                } else if (param.action === "confirm") {
                    removeDataForComfirm(comment_state2.idx);
                } else if (param.action === "confirmRemoveForAdmin") {
                    removeData(state.idx);
                } else if (param.action === "checkPwForConfirmRemove") {
                    const param2: types.ReqConfirmPw = {
                        idx: state.idx,
                        pw: param.pw,
                    };
                    removeConfirmData(param2);
                } else {
                    router.back();
                }
            };

            const isDelete = () => {
                if ((user.isLogin() && state.data.meIdx === user.userInfo.idx) || state.hasAuth) {
                    state.modalTab = 10;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 9;
                    state.modalTitle = "알림";
                    state.modalContent = "제보 시 설정한 비밀번호를 입력해 주세요.";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const commentAdd = async () => {
                const param: types.ReqReportComment = {
                    type: 2,
                    idx: state.idx,
                    content: form_state.commentContent,
                };
                const res = await apiService.report.commentAdd(param);
                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;

                    getComments();
                    form_state.commentContent = "";
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const commentSave = async (item: any) => {
                const param: types.ReqReportComment = {
                    type: 2,
                    idx: comment_state.idx,
                    content: comment_state.content,
                };

                const res = await apiService.report.commentModify(param);
                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;

                    getDetail();
                    form_state.commentContent = "";
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const commentModify = (item: any) => {
                comment_state.mode = "modify";

                comment_state.idx = item.idx;
                comment_state.content = item.content;
            };

            const confirmCommentRemove = async (idx: number) => {
                comment_state2.idx = idx;
                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "댓글을 삭제하시겠습니까?";
                state.isShowModal = true;
            };

            const commentCancel = () => {
                comment_state.mode = "";
                comment_state.idx = 0;
                comment_state.content = "";
                comment_state.pw = "";
            };

            const selectReportState = (stateNum: number) => {
                state.data.reportState = stateNum;
                state.isPossible = false;
            };

            const currentReason = computed(() => {
                const reasonIndex = state.data.reason != null ? state.data.reason - 1 : 0;
                return reasons[reasonIndex];
            });

            const selectReason = (value: number) => {
                state.data.reason = value;
                state.isReason = false;
            };

            const stateSave = async () => {
                if (state.data.reportState === 2 && !state.data.reportMemo) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "고발 사유를 확인해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqReportForAnswer = {
                        idx: state.idx,
                        state: state.data.state,
                        gubun: state.data.gubun,
                        isReport: state.data.isReport,
                        reportState: state.data.reportState,
                        reportType: state.data.reportType,
                        reportMemo: state.data.reportMemo,
                        reason: state.data.reason,
                        memo: state.data.memo,
                    };
                    const res = await apiService.report.answer(2, param);

                    if (res.returnCode === 0) {
                        state.modalTab = 8;
                        state.modalTitle = "알림";
                        state.modalContent = "저장이 완료되었습니다.";
                        state.isShowModal = true;

                        getDetail();
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const edit = (item: any) => {
                state.isShowBtn = true;
                comment_state.idx = item.idx;
                comment_state.mode = "";
            };

            return {
                state,
                form_state,
                router,
                changeTab,
                subMenuTab,
                closeModal,
                callBackModal,
                isDelete,
                downloadFile,
                CommonUtils,
                global,
                user,
                comment_state,
                commentModify,
                commentSave,
                confirmCommentRemove,
                commentCancel,
                commentAdd,
                reasons,
                selectReportState,
                currentReason,
                selectReason,
                stateSave,
                edit,
            };
        },
    };
</script>

<style scoped>
    .admin_save_btn {
        align-items: flex-end !important;
    }
</style>
